"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketContext = void 0;
const react_1 = require("react");
exports.WebsocketContext = react_1.createContext(null);
//# sourceMappingURL=web-socket-context.js.map